import React, { useEffect, useState } from 'react';

const LoadingSpinner = ({ message = "Loading data..." }) => {
  const [positions, setPositions] = useState({
    node1: { x: 0, y: 0 },
    node2: { x: 0, y: 0 },
    node3: { x: 0, y: 0 },
    node4: { x: 0, y: 0 },
    node5: { x: 0, y: 0 }
  });

  useEffect(() => {
    const animate = () => {
      setPositions({
        node1: {
          x: Math.random() * 8 - 4,
          y: Math.random() * 8 - 4
        },
        node2: {
          x: Math.random() * 8 - 4,
          y: Math.random() * 8 - 4
        },
        node3: {
          x: Math.random() * 8 - 4,
          y: Math.random() * 8 - 4
        },
        node4: {
          x: Math.random() * 8 - 4,
          y: Math.random() * 8 - 4
        },
        node5: {
          x: Math.random() * 8 - 4,
          y: Math.random() * 8 - 4
        }
      });
    };

    const interval = setInterval(animate, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        style={{ marginBottom: '1rem' }}
      >
        {/* Lines connecting to outer nodes */}
        <line
          x1="60"
          y1="60"
          x2={25 + positions.node1.x}
          y2={25 + positions.node1.y}
          stroke="#1abc9c"
          strokeWidth="2"
          style={{ transition: 'all 0.6s ease-in-out' }}
        />
        <line
          x1="60"
          y1="60"
          x2={75 + positions.node2.x}
          y2={20 + positions.node2.y}
          stroke="#1abc9c"
          strokeWidth="2"
          style={{ transition: 'all 0.6s ease-in-out' }}
        />
        <line
          x1="60"
          y1="60"
          x2={95 + positions.node3.x}
          y2={60 + positions.node3.y}
          stroke="#1abc9c"
          strokeWidth="2"
          style={{ transition: 'all 0.6s ease-in-out' }}
        />
        <line
          x1="60"
          y1="60"
          x2={25 + positions.node4.x}
          y2={75 + positions.node4.y}
          stroke="#1abc9c"
          strokeWidth="2"
          style={{ transition: 'all 0.6s ease-in-out' }}
        />
        <line
          x1="60"
          y1="60"
          x2={60 + positions.node5.x}
          y2={95 + positions.node5.y}
          stroke="#1abc9c"
          strokeWidth="2"
          style={{ transition: 'all 0.6s ease-in-out' }}
        />

        {/* Striped outer nodes */}
        <g transform={`translate(${positions.node1.x}, ${positions.node1.y})`} style={{ transition: 'all 0.6s ease-in-out' }}>
          <circle cx="25" cy="25" r="10" fill="white" stroke="#1abc9c" strokeWidth="2" />
          <circle cx="25" cy="25" r="10" fill="url(#stripePattern)" />
        </g>

        <g transform={`translate(${positions.node2.x}, ${positions.node2.y})`} style={{ transition: 'all 0.6s ease-in-out' }}>
          <circle cx="75" cy="20" r="10" fill="white" stroke="#1abc9c" strokeWidth="2" />
          <circle cx="75" cy="20" r="10" fill="url(#stripePattern)" />
        </g>

        <g transform={`translate(${positions.node4.x}, ${positions.node4.y})`} style={{ transition: 'all 0.6s ease-in-out' }}>
          <circle cx="25" cy="75" r="10" fill="white" stroke="#1abc9c" strokeWidth="2" />
          <circle cx="25" cy="75" r="10" fill="url(#stripePattern)" />
        </g>

        {/* Solid outer nodes */}
        <g transform={`translate(${positions.node3.x}, ${positions.node3.y})`} style={{ transition: 'all 0.6s ease-in-out' }}>
          <circle cx="95" cy="60" r="10" fill="#1abc9c" />
        </g>

        <g transform={`translate(${positions.node5.x}, ${positions.node5.y})`} style={{ transition: 'all 0.6s ease-in-out' }}>
          <circle cx="60" cy="95" r="10" fill="#1abc9c" />
        </g>

        {/* Center node */}
        <circle cx="60" cy="60" r="15" fill="white" stroke="#1abc9c" strokeWidth="3" />
        <circle cx="60" cy="60" r="10" fill="#1abc9c" />

        {/* Pattern definition for stripes */}
        <defs>
          <pattern id="stripePattern" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="8" stroke="#1abc9c" strokeWidth="4" />
          </pattern>
        </defs>
      </svg>

      <p style={{
        color: '#1abc9c',
        fontSize: '1rem',
        fontWeight: '500',
        margin: '0'
      }}>
        {message}
      </p>
    </div>
  );
};

export default LoadingSpinner;